import { pickKeys } from 'lib/object/objectUtils'

export function slimifyGeo(geo: App.GeoState): Pick<App.GeoState, 'currentRegionCode' | 'currentCurrency'> {
  return pickKeys(['currentRegionCode', 'currentCurrency'], geo)
}

export function getPlaceKey(latitude?: number, longitude?: number, levels?: Array<App.PlaceType>): string {
  if (latitude === undefined || longitude === undefined || !Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return 'no-lat-long'
  }

  if (!levels) {
    return `${latitude}-${longitude}`
  }

  return `${latitude}-${longitude}-${levels?.join(',')}`
}

/** Keys `geo.currencyConversionRates` by currency pair, e.g. AUD-NZD */
export function getCurrencyConversionRateKey(baseCurrencyCode: string, targetCurrencyCode: string): string {
  return `${baseCurrencyCode}-${targetCurrencyCode}`
}
